// This file is automatically generated. Do not edit manually.

import { makeAxiosRequest } from "src/api/utils/apiClient";
import { t } from "i18next";

export namespace PurchaseOrderLinkedOrdersApi {
	export async function getLinkedOrdersForPurchaseOrder(args: {
		purchaseOrderId: number;
	}): Promise<Array<PurchaseOrderLinkedOrdersApi_PurchaseOrderLinkedOrderDto>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/purchase/purchaseOrder/linkedOrders/getLinkedOrdersForPurchaseOrder",
			method: "POST",
			data: {
				purchaseOrderId: args.purchaseOrderId,
			},
		});
		return response as Array<PurchaseOrderLinkedOrdersApi_PurchaseOrderLinkedOrderDto>;
	}
}

export const PurchaseOrderLinkedOrdersApi_PurchaseOrderLinkedOrderTypeValues = ["PROJECT", "CUSTOMER_ORDER"] as const;

export type PurchaseOrderLinkedOrdersApi_PurchaseOrderLinkedOrderType =
	(typeof PurchaseOrderLinkedOrdersApi_PurchaseOrderLinkedOrderTypeValues)[number];

export const getPurchaseOrderLinkedOrdersApi_PurchaseOrderLinkedOrderTypeLabels = () => ({
	PROJECT: t("project"),
	CUSTOMER_ORDER: t("customer_order"),
});

export const getPurchaseOrderLinkedOrdersApi_PurchaseOrderLinkedOrderTypeLabel = (
	value: PurchaseOrderLinkedOrdersApi_PurchaseOrderLinkedOrderType,
): string => {
	return getPurchaseOrderLinkedOrdersApi_PurchaseOrderLinkedOrderTypeLabels()[value];
};

export interface PurchaseOrderLinkedOrdersApi_PurchaseOrderLinkedOrderDto {
	description: string;
	id: number;
	linkId: number;
	type: PurchaseOrderLinkedOrdersApi_PurchaseOrderLinkedOrderType;
}
